import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Search.css';
import LaptopAcceForm from '../LaptopAccessiories/LaptopAcceForm';
import LaptopAcce from '../LaptopAccessiories/LaptopAcce';
import EmployeeForm from './EmployeeForm';
import TwoWheelerForm from '../TwoWheeler/TwoWheelerForm';
import Mobile from '../Mobile/Mobile';
import Accessiories from '../OtherAccessories/Accessories';
import { useInput } from '../Context';
import EmployeeDetails from '../EmployeeDetails/EmployeeDetails';

const API_BASE = 'https://api.assetview.warrantyindia.com';

const Search = () => {
  const { inputValue, handleSearch, searchResults } = useInput();
  const [isSearchBarActive, setIsSearchBarActive] = useState(true);
  const [editingData, setEditingData] = useState(null); // Track the row being edited/viewed
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isFormOpen2, setIsFormOpen2] = useState(false);
  const [formMode, setFormMode] = useState(null);
  const [loading, setLoading] = useState(false);          // for update submit
  const [deletingId, setDeletingId] = useState(null);     // track which row is deleting
  const [user, setUser] = useState(null);

  const [attachOpen, setAttachOpen] = useState(false);
const [attachForId, setAttachForId] = useState(null);
const [attachFiles, setAttachFiles] = useState([]);
const [attachUploading, setAttachUploading] = useState(false);
const [previewOpen, setPreviewOpen] = useState(false);
const [previewImages, setPreviewImages] = useState([]);

  useEffect(() => {
    const storedPreference = sessionStorage.getItem('user');
    setUser(storedPreference);
  }, []);

  const handleToggleForm = () => setIsFormOpen(prev => !prev);
  const handleToggleForm2 = () => setIsFormOpen2(prev => !prev);

  // Search input change (input itself is hidden but you may reuse anywhere)
  const handleInputChange = (e) => {
    const term = e.target.value;
    handleSearch(term);
  };

  const handleViewClick = (data) => {
    setEditingData(data);
    setFormMode('view');
  };

  const handleEditClick = (data) => {
    setEditingData(data);
    setFormMode('edit');
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEditingData(prev => ({ ...prev, [name]: value }));
  };

  // DELETE a record
  const handleDelete = async (id) => {
    const ok = window.confirm('Are you sure you want to delete this entry? This action cannot be undone.');
    if (!ok) return;

    try {
      setDeletingId(id);
      await axios.delete(`${API_BASE}/api/deleteaccessories1/${id}`);
      alert('Entry deleted successfully.');

      // Close modal if the deleted item is currently open
      if (editingData && Number(editingData.id) === Number(id)) {
        setEditingData(null);
      }

      // Refresh the current list (re-run the last search query)
      handleSearch(inputValue || '');
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete. Please try again.');
    } finally {
      setDeletingId(null);
    }
  };


  const openAttachModal = (row) => {
  setAttachForId(row.id);
  setAttachFiles([]);
  setAttachOpen(true);
};

const closeAttachModal = () => {
  setAttachOpen(false);
  setAttachForId(null);
  setAttachFiles([]);
};

const onPickAttachFiles = (e) => {
  const files = Array.from(e.target.files || []);
  if (files.length > 6) {
    alert("Maximum 6 images allowed.");
    e.target.value = "";
    return;
  }
  setAttachFiles(files);
};

const uploadAttachments = async () => {
  if (!attachForId) return;
  if (!attachFiles.length) {
    alert("Please select at least 1 image.");
    return;
  }

  try {
    setAttachUploading(true);
    const fd = new FormData();
    attachFiles.forEach((f) => fd.append("images", f));

    // ✅ if your router is mounted under /api, then use `${API_BASE}/api/...`
    // In your backend sample, you use routes like /assets/mine and /assets
    // So likely base = https://api.assetview.warrantyindia.com/api
    await axios.post(`${API_BASE}/api/assets/${attachForId}/attachments`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    alert("Attachments uploaded successfully.");

    // refresh list
    handleSearch(inputValue || "");
    closeAttachModal();
  } catch (err) {
    console.error("Upload failed:", err);
    alert("Upload failed. Please try again.");
  } finally {
    setAttachUploading(false);
  }
};

const openPreview = (row) => {
  const arr = Array.isArray(row.attachments) ? row.attachments : [];
  setPreviewImages(arr);
  setPreviewOpen(true);
};

const closePreview = () => {
  setPreviewOpen(false);
  setPreviewImages([]);
};

  // UPDATE (edit) submit
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!editingData?.employee_name) {
      alert('Please fill in all required fields.');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.put(`${API_BASE}/update/${editingData.id}`, editingData);

      if (response.status === 200) {
        alert('Details updated successfully');
        setEditingData(null);
        handleSearch(inputValue || '');
      }
    } catch (error) {
      console.error('Error updating data:', error);
      alert('Failed to update. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  };

  const formatDateToDDMMYYYY = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div
      className={`search-container ${isSearchBarActive ? 'active' : ''}`}
      style={{ scrollBehavior: 'smooth', position: 'absolute', top: '0', left: '0', right: '0', margin: '0px' }}
    >
      <EmployeeDetails />

      {/* Hidden input but kept wired to search handler if you want to expose later */}
      <input
        type="text"
        placeholder="Search by Employee Name or Email"
        className="search-bar"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setIsSearchBarActive(true)}
        onBlur={() => inputValue === '' && setIsSearchBarActive(true)}
        style={{ display: 'none' }}
      />

      {(user === 'laptop' || user === 'admin') && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', cursor: 'pointer' }}>
          <h2 style={{ color: 'red' }}>LAPTOP</h2>
          {/* Icons suppressed as in your original */}
        </div>
      )}

      <div>{isFormOpen && <EmployeeForm />}</div>
      <div>{isFormOpen2 && <LaptopAcceForm />}</div>

      {(user === 'laptop' || user === 'admin') && (
        <div className="search-results">
          {searchResults.length > 0 ? (
            <table border={5} className="result-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f1f1f1', textAlign: 'center' }}>
                  <th style={{ padding: '10px', width: '150px' }}>Date of Issue</th>
                  <th style={{ padding: '10px', width: '150px' }}>Model Name</th>
                  <th style={{ padding: '10px', width: '150px' }}>Serial No.</th>
                  <th style={{ padding: '10px', width: '150px' }}>Device Transferred</th>
                  <th style={{ padding: '10px', width: '150px' }}>Device Intake</th>
                  <th style={{ padding: '10px', width: '150px' }}>Reporting Manager</th>
                  <th style={{ padding: '10px', width: '150px' }}>Device Intake Date</th>
                  <th style={{ padding: "10px", width: "150px" }}>Attachments</th>
                  <th colSpan={3} style={{ padding: '10px', width: '150px', textAlign: 'center' }}>Actions</th>
                  
                </tr>
              </thead>
              <tbody>
                {searchResults.map((result, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                    <td style={{ padding: '10px', width: '150px' }}>
                      {result.date_of_issue ? formatDateToDDMMYYYY(result.date_of_issue) : ''}
                    </td>
                    <td style={{ padding: '10px', width: '150px' }}>{result.model_name || ''}</td>
                    <td style={{ padding: '10px', width: '150px' }}>{result.serial_no || ''}</td>
                    <td style={{ padding: '10px', width: '150px' }}>{result.device_transferred || ''}</td>
                    <td style={{ padding: '10px', width: '150px' }}>{result.device_intake || ''}</td>
                    <td style={{ padding: '10px', width: '150px' }}>{result.reporting_manager || ''}</td>
                    <td style={{ padding: '10px', width: '150px' }}>
                      {result.device_transferred_date ? formatDateToDDMMYYYY(result.device_transferred_date) : ''}
                    </td>
                    <td style={{ padding: "10px", width: "260px" }}>
  <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
    <button onClick={() => openAttachModal(result)} style={{ width: 130 }}>
      Attach Images
    </button>

    {Array.isArray(result.attachments) && result.attachments.length > 0 && (
      <button onClick={() => openPreview(result)} style={{ width: 130 }}>
        View ({result.attachments.length})
      </button>
    )}
  </div>

  {/* ✅ small thumbnail strip */}
  {Array.isArray(result.attachments) && result.attachments.length > 0 && (
    <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
      {result.attachments.slice(0, 3).map((p, i) => {
        const url = `${API_BASE}${p}`;
        return (
          <a key={i} href={url} target="_blank" rel="noreferrer" title="Open image">
            <img
              src={url}
              alt={`att-${i}`}
              style={{ width: 46, height: 46, objectFit: "cover", borderRadius: 8, border: "1px solid #ddd" }}
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          </a>
        );
      })}
      {result.attachments.length > 3 && (
        <div style={{ fontSize: 12, color: "#666", alignSelf: "center" }}>
          +{result.attachments.length - 3} more
        </div>
      )}
    </div>
  )}

  {(!result.attachments || result.attachments.length === 0) && (
    <div style={{ marginTop: 6, fontSize: 12, color: "#777" }}>No attachments</div>
  )}
</td>


                    <td style={{ padding: '10px', display: 'flex', gap: '10px', justifyContent: 'center', border: 'none' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <button onClick={() => handleViewClick(result)} style={{ fontSize: '15px', width: '120px' }}>
                        View
                      </button>
                      <button onClick={() => handleEditClick(result)} style={{ fontSize: '15px', width: '120px' }}>
                        Edit
                      </button>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <button style={{ fontSize: '15px', width: '120px' }} onClick={handleToggleForm}>
                        Add New
                      </button>
                      <button style={{ fontSize: '15px', width: '150px' }} onClick={handleToggleForm2}>
                        New Accessiories
                      </button>
                      </div>
                    </td>

                    {/* NEW: Delete button */}
                    

                    
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <button
                style={{ padding: '10px', background: 'green', color: 'white', border: 'none', cursor: 'pointer' }}
                onClick={handleToggleForm}
              >
                Create Laptop Data
              </button>
            </div>
          )}
        </div>
      )}

      {/* Edit/View Modal */}
      {editingData && (
        <div className="edit-form-popup">
          <div className="edit-form">
            <h3>{formMode === 'edit' ? 'Edit Employee Details' : 'View Employee Details'}</h3>

            {/* Optional inline delete for the same record from the modal */}
            <div style={{ marginBottom: 12 }}>
              <button
                onClick={() => handleDelete(editingData.id)}
                disabled={deletingId === editingData.id}
                style={{ background: '#b00020', color: '#fff', padding: '6px 10px', border: 'none', marginRight: 8 }}
                title="Delete this entry"
              >
                {deletingId === editingData.id ? 'Deleting…' : 'Delete'}
              </button>
              <button onClick={() => setEditingData(null)} style={{ padding: '6px 10px' }}>
                Close
              </button>
            </div>

            <form onSubmit={handleFormSubmit} className="edit-form-container">
              <div className="form-field">
                <label>Employee Name:</label>
                <input
                  type="text"
                  name="employee_name"
                  value={editingData.employee_name || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Regional Office:</label>
                <input
                  type="text"
                  name="regional_office"
                  value={editingData.regional_office || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Contact No.:</label>
                <input
                  type="text"
                  name="contact_no"
                  value={editingData.contact_no || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Email:</label>
                <input
                  type="text"
                  name="personal_email_id"
                  value={editingData.personal_email_id || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Address:</label>
                <input
                  type="text"
                  name="address"
                  value={editingData.address || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Date of Issue:</label>
                <input
                  type="date"
                  name="date_of_issue"
                  value={editingData.date_of_issue ? formatDateToYYYYMMDD(editingData.date_of_issue) : ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Model Name:</label>
                <input
                  type="text"
                  name="model_name"
                  value={editingData.model_name || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Serial No.:</label>
                <input
                  type="text"
                  name="serial_no"
                  value={editingData.serial_no || ''}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                />
              </div>

              <div className="form-field">
                <label>Device Transferred:</label>
                <select
                  name="device_transferred"
                  value={editingData.device_transferred || 'no'}
                  onChange={handleFormChange}
                  disabled={formMode === 'view'}
                >
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>

              {editingData.device_transferred === 'yes' && (
                <>
                  <div className="form-field">
                    <label>Employee Name (Transferred):</label>
                    <input
                      type="text"
                      name="device_transferred_employee_name"
                      value={editingData.device_transferred_employee_name || ''}
                      onChange={handleFormChange}
                      disabled={formMode === 'view'}
                    />
                  </div>

                  <div className="form-field">
                    <label>Device Intake:</label>
                    <select
                      name="device_intake"
                      className="custom-dropdown"
                      value={editingData.device_intake || 'no'}
                      onChange={handleFormChange}
                      disabled={formMode === 'view'}
                    >
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>

                  {editingData.device_intake === 'yes' && (
                    <>
                      <div className="form-field">
                        <label>Reporting Manager:</label>
                        <input
                          type="text"
                          name="reporting_manager"
                          value={editingData.reporting_manager || ''}
                          onChange={handleFormChange}
                          disabled={formMode === 'view'}
                        />
                      </div>

                      <div className="form-field">
                        <label>Device Intake Date:</label>
                        <input
                          type="date"
                          name="device_transferred_date"
                          value={
                            editingData.device_transferred_date
                              ? formatDateToYYYYMMDD(editingData.device_transferred_date)
                              : ''
                          }
                          onChange={handleFormChange}
                          disabled={formMode === 'view'}
                        />
                      </div>

                      <div className="form-field">
                        <label>Exit Formality Complete:</label>
                        <select
                          name="exit_formality_complete"
                          className="custom-dropdown"
                          value={editingData.exit_formality_complete || 'no'}
                          onChange={handleFormChange}
                          disabled={formMode === 'view'}
                        >
                          <option value="no">No</option>
                          <option value="yes">Yes</option>
                        </select>
                      </div>
                    </>
                  )}
                </>
              )}

              {formMode === 'edit' && (
                <button type="submit" disabled={loading}>
                  {loading ? 'Saving…' : 'Save Changes'}
                </button>
              )}

              <button type="button" onClick={() => setEditingData(null)} style={{ marginLeft: 8 }}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {(user === 'laptop' || user === 'admin') && <LaptopAcce />}
      {(user === 'laptop' || user === 'admin') && <Mobile />}
      {(user === 'laptop' || user === 'admin') && <Accessiories />}

      {(user === 'twowheller' || user === 'admin') && <TwoWheelerForm />}

      {attachOpen && (
  <div className="edit-form-popup">
    <div className="edit-form">
      <h3>Upload Attachments (Max 6 images)</h3>

      <input type="file" accept="image/*" multiple onChange={onPickAttachFiles} />

      <div style={{ marginTop: 8, fontSize: 13 }}>
        Selected: {attachFiles.length} / 6
      </div>

      <div style={{ marginTop: 12, display: "flex", gap: 10 }}>
        <button onClick={uploadAttachments} disabled={attachUploading}>
          {attachUploading ? "Uploading..." : "Upload"}
        </button>
        <button onClick={closeAttachModal} type="button">
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

{previewOpen && (
  <div className="edit-form-popup">
    <div className="edit-form" style={{ maxWidth: 700 }}>
      <h3>Attachments</h3>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
        {previewImages.map((p, i) => {
          const url = `${API_BASE}${p}`;
          return (
            <a key={i} href={url} target="_blank" rel="noreferrer">
              <img
                src={url}
                alt={`preview-${i}`}
                style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 10, border: "1px solid #ddd" }}
              />
            </a>
          );
        })}
      </div>

      <div style={{ marginTop: 12 }}>
        <button onClick={closePreview}>Close</button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default Search;
